module.exports = __webpack_public_path__ + "my-team_white.3e5309431a8d685e6580.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/my-team_white.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/my-team_white.svg
// module chunks = styles